import { render, staticRenderFns } from "./PremiumStatCard.vue?vue&type=template&id=6edda2fd&scoped=true"
import script from "./PremiumStatCard.vue?vue&type=script&lang=js"
export * from "./PremiumStatCard.vue?vue&type=script&lang=js"
import style0 from "./PremiumStatCard.vue?vue&type=style&index=0&id=6edda2fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edda2fd",
  null
  
)

export default component.exports